const payout = {
  title: 'Payouts',
  active_campaign: 'Active Campaign',

  stats: {
    total_payouts_month: 'Total Payouts This Month',
    total_payouts_month_hint: 'Total Paid Out This Month',
    upcoming_payouts: 'Upcoming Payouts',
    upcoming_payouts_hint: 'Expected Payout',
    pending_approval: 'Pending Approval',
    pending_approval_hint: 'Awaiting Approval',
    last_payout_date: 'Last Payout Date',
    last_payout_date_hint: 'Most Recent Payout',
    total_winners: 'Total Winners',
    total_winners_hint: 'Across All Prize Types',
    paid_winners: 'Paid Winners',
    paid_winners_hint: '{{percent}}% Of Total Winners',
    pending_winners: 'Pending Winners',
    pending_winners_hint: '{{percent}}% Of Total Winners',
    prize_types: 'Prize Types',
    prize_types_hint: 'Distinct Prize Types'
  },

  filters: {
    this_year: 'This year',
    all_accounts: 'All accounts',
    all_types: 'All types',
    all_statuses: 'All statuses',
    export: 'Export'
  },

  detail: {
    title: 'Payout Detail',
    reference: 'Payout Reference',
    date: 'Payout Date',
    prize_type: 'Prize Type',
    prize_name: 'Prize Name',
    total_winners: 'Total Winners',
    view_all_detail: 'View all detail',
    empty_title: 'No payout yet',
    empty_hint: 'Your most recent payout will appear here.'
  },

  prize_security: {
    title: 'Prize Security Account Summary',
    available_balance: 'Available Balance',
    weekly_reserve: 'Weekly Prize Reserve',
    monthly_reserve: 'Monthly Prize Reserve',
    next_payout_date: 'Next Payout Date',
    next_payout_amount: 'Next Payout Amount'
  },

  winners_by_status: {
    title: 'Winners By Status',
    total_winners: 'Total Winners',
    paid: 'Paid',
    verified: 'Verified',
    pending: 'Pending'
  },

  top_prize_type: {
    title: 'Top Prize Type',
    types: {
      fuel_voucher: 'Fuel Voucher',
      grocery_gift_card: 'Grocery Gift Card',
      cash_transfer: 'Cash Transfer',
      television: 'Television',
      smartphone: 'Smartphone'
    }
  },

  recent_transactions: {
    title: 'Recent Payout Transactions',
    view_all: 'View All',
    empty_title: 'No recent payout yet',
    empty_hint: 'Recent payout transactions will appear here when activity is recorded.',
    columns: {
      date: 'Date',
      payout_id: 'Payout ID',
      prize_type: 'Prize Type',
      prize_name: 'Prize Name',
      winners: 'Winners',
      amount: 'Amount',
      status: 'Status'
    }
  },

  winners_information: {
    search_placeholder: 'Search',
    all_prize_types: 'All Prize Types',
    all_statuses: 'All statuses',
    export: 'Export',
    empty_title: 'No winner information yet',
    empty_hint: 'Winner information will appear here when activity is recorded.',
    columns: {
      winner_name: 'Winner Name',
      phone_number: 'Phone Number',
      location: 'Location',
      prize_type: 'Prize Type',
      prize_name: 'Prize Name',
      payout_reference: 'Payout Reference',
      status: 'Status'
    },
    table: {
      selected: '{{count}} of {{total}} row(s) selected.',
      page_of: 'Page {{page}} of {{total}}'
    }
  },

  winner_detail: {
    breadcrumb: 'Winner Detail',

    stats: {
      winner_status: 'Winner Status',
      prize_type: 'Prize Type',
      prize_value: 'Prize Value',
      payout_date: 'Payout Date'
    },

    profile: {
      title: 'Winner Profile & Detail',
      winner_name: 'Winner Name',
      phone_number: 'Phone number',
      location: 'Location',
      campaign: 'Campaign',
      prize_category: 'Prize Category',
      prize_name: 'Prize Name',
      payout_reference: 'Payout Reference',
      winner_batch: 'Winner batch',
      verification_method: 'Verification Method',
      status: 'Status',
      date_won: 'Date Won',
      note: 'Note'
    },

    proof: {
      title: 'Proof Of Payout',
      uploaded_by: 'Uploaded By',
      uploaded_date: 'Uploaded Date',
      file_type: 'File Type',
      file_size: 'File Size',
      download_proof: 'Download Proof',
      view_image: 'View Image',
      photo_label: 'Photo',
      empty: 'No proof of payout uploaded yet.'
    },

    payout_prize_detail: {
      title: 'Payout & Prize Detail',
      funding_source: 'Funding Source',
      prize_amount: 'Prize Amount',
      delivery_method: 'Delivery Method',
      merchant_branch: 'Merchant Branch',
      approved_by: 'Approved By',
      notes: 'Notes'
    },

    activity_timeline: {
      title: 'Activity Timeline',
      winner_selected: 'Winner Selected',
      merchant_confirmed: 'Merchant Confirmed',
      prize_approved: 'Prize Approved',
      prize_handed_over: 'Prize Handed Over',
      proof_uploaded: 'Proof Uploaded',
      completed: 'Completed'
    }
  }
}

export default payout
